
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";
export default defineComponent({
  name: "LoginForm",
  components: {
    RouterLink,
  },

  data() {
    return {
      email: "",
      password: "",
      confirm_password: "",
      privacy_policy: false,
      info_emails: false,
      errors: {},
      message: "",
    };
  },
  methods: {
    register() {
      // Implement your registration logic here
    },
  },
});
